import React from 'react';
import styled from 'styled-components';
import { colorThemeGenerator, ButtonPrimary, Type } from '@spotify-internal/encore-creator-web';
import {
  gray10,
  white,
  spacer16,
  spacer20,
  screenMdMin,
  midnight,
  spacer48,
} from '@spotify-internal/encore-foundation';
import { pageConstraintStyles, PAGE_GUTTER } from './styles';
import { TextWithDesktopLineBreak } from '../Shared/TextWithDesktopLineBreak';
import { FormattedMessage } from 'react-intl';
import { auth } from '../../lib/Request';

export function ClaimBanner() {
  return (
    <ClaimBannerContainer>
      <ClaimBannerContentWrapper>
        <ClaimBannerBackground />
        <ClaimBannerContent>
          <ClaimBannerHeader>
            <FormattedMessage
              id="landing-page.claim-banner.podcast-already"
              defaultMessage="Podcast already on Spotify?"
            />
          </ClaimBannerHeader>
          <Type as="p" variant={Type.body1} style={{ color: midnight }}>
            <FormattedMessage
              id="landing-page.claim-banner.claim-your-podcast-and-get"
              defaultMessage="Claim your podcast and get instant access to your current stats and audience data."
            />
            <TextWithDesktopLineBreak variant={Type.body1} style={{ color: midnight }}>
              <FormattedMessage
                id="landing-page.claim-banner.or-you-can-add"
                defaultMessage="Or you can add your show to Spotify in a few easy steps."
              />
            </TextWithDesktopLineBreak>
          </Type>
          <ButtonPrimary
            onClick={() => auth.login(`${window.location.origin}/submit`)}
            theme={{
              ...colorThemeGenerator({
                primaryColor: midnight,
                primaryColorText: white,
                primaryColorFocusText: white,
                primaryColorActiveText: white,
              }),
            }}
            style={{ marginTop: spacer20 }}
          >
            <FormattedMessage
              id="landing-page.claim-banner.claim-your-podcast"
              defaultMessage="Claim Your Podcast"
            />
          </ButtonPrimary>
        </ClaimBannerContent>
      </ClaimBannerContentWrapper>
    </ClaimBannerContainer>
  );
}

const ClaimBannerContainer = styled.div`
  width: 100%;
  background-color: white;

  @media (min-width: ${screenMdMin}) {
    margin-top: ${spacer48};
  }
`;

const ClaimBannerContentWrapper = styled.div`
  color: ${gray10};
  position: relative;

  @media (min-width: ${screenMdMin}) {
    ${pageConstraintStyles}
  }
`;

const ClaimBannerBackground = styled.div`
  position: absolute;
  background-image: url(/images/landing_page/bg-04-podcast-already.svg);
  background-origin: border-box;
  background-position-x: right;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;
  width: 1650px;
`;

const ClaimBannerContent = styled.div`
  padding: 42px ${spacer16};

  @media (min-width: ${screenMdMin}) {
    padding: 108px 0 114px ${PAGE_GUTTER};
    position: relative;
  }
`;

const ClaimBannerHeader = styled(Type).attrs({
  forwardedAs: 'h2',
  variant: Type.heading2,
})`
  font-size: 28px;
  line-height: 32px;
  padding-bottom: 28px;
  color: ${midnight};

  @media (min-width: ${screenMdMin}) {
    font-size: 48px;
    line-height: 1em;
  }
`;
